import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { imageSetAvatarThunk } from "../image/imageSetAvatar";
import { ObjectTarget } from "../../app/permissions";

export interface DptoState {
  state: LoadStateInfo;
  selected?: DptoInfo;
}

const initialState: DptoState = {
  state: notStarted(),
};


export interface RetrieveDptoRequest {
  dptoId: string;
}

export const retrieveDpto = createAsyncThunk(
  "retrieveDpto",
  async (param: RetrieveDptoRequest, thunkAPI) => {
    console.debug("retrieve dpto");

    const response = await fetch(`${getBackendUrl()}/api/dpto/${param.dptoId}`, {
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
      }
    });

    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);


export const dptoSlice = createSlice({
  name: "dpto",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    select: (state, action: PayloadAction<DptoInfo | undefined>) => {
      console.trace(`select :: ${action.payload?.name}`);
      state.selected = action.payload;
    },
    clean: (state) => {
      state.state = notStarted();
      state.selected = undefined;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(retrieveDpto.pending, (state, action) => {
        state.state =  loading();
        state.selected = undefined;
      })
      .addCase(retrieveDpto.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.selected = action.payload;
      })
      .addCase(retrieveDpto.rejected, (state, action) => {
        state.state = error(action);
      })
      .addCase(imageSetAvatarThunk.fulfilled, (state, action) => {
        if(state.selected
          && action.meta.arg.objectTarget == ObjectTarget.DPTO
          && action.meta.arg.targetId == state.selected?.id
        ) {
          state.selected.url = action.payload;
        }
      });
    },
});

export interface DptoInfo {
  id: string;
  name: string;
  url?: string;
  schoolId: string;
}

export const { } = dptoSlice.actions;

export const selectDpto = (state: RootState) => state.dpto;

export default dptoSlice.reducer;
